import { render, staticRenderFns } from "./CentralWebhookConfig.vue?vue&type=template&id=1da1454a&scoped=true&"
import script from "./CentralWebhookConfig.vue?vue&type=script&lang=js&"
export * from "./CentralWebhookConfig.vue?vue&type=script&lang=js&"
import style0 from "./CentralWebhookConfig.vue?vue&type=style&index=0&id=1da1454a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da1454a",
  null
  
)

export default component.exports